import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'

import type { ReactElement } from 'react'
import type { Props as SelectProps } from 'react-select'

import UiMultiSelectInput from '../../Basic/MultiSelectInput'

import CustomOption from '~/components/SelectOptions/CustomOption'

import '../../input-common.scss'

interface Props extends Omit<SelectProps, 'isDisabled' | 'isMulti' | 'onChange'> {
  defaultValue?: IOption
  disabled?: boolean
  focus?: boolean
  isClearable?: boolean
  isSearchable?: boolean
  label?: string
  labelPosition?: 'left' | 'top'
  menuClassName?: string
  name: string
  onChange?: (value: IOption[] | IOption) => void
}

const MultiSelectInput = ({ className, focus, name, onChange, ...props }: Props): ReactElement => {
  const [field, { error, touched }, { setValue }] = useField<IOption[] | IOption>(name)

  const inputComponentClassNames = classNames('input-component multi-select-input-component input-container', className)

  const fieldContainerClasses = classNames('field-container', { erroneous: touched && error })

  const handleChange = (value: IOption[] | IOption) => {
    setValue(value)
    onChange && onChange(value)
  }

  return (
    <div className={inputComponentClassNames}>
      <div className={fieldContainerClasses}>
        <UiMultiSelectInput
          {...props}
          {...field}
          autoFocus={focus}
          className={classNames('multi-select-input input-wrapper', { erroneous: touched && error })}
          components={{ Option: CustomOption, ...props.components }}
          onChange={(value: unknown) => handleChange(value as IOption[])}
        />
      </div>
      {touched && error ? <ErrorMessage className="error-message" component="span" name={name} /> : null}
    </div>
  )
}

export default MultiSelectInput
